import React from 'react';

//导入antd
import { Modal, Form } from 'antd';

//导入登录组件
import { Login } from '@src/components/Login';

//登录弹窗组件
export const LoginModal = (props: any) => {
    const { login, loginModalVisible, setLoginModalVisible, loginPath } = props;

    const [form] = Form.useForm();

    return (
        <Modal
            title={null}
            open={loginModalVisible}
            footer={null}
            onCancel={() => {
                //清空表单
                form.resetFields();
                setLoginModalVisible(false);
            }}
        >
            <Login form={form} login={login} loginPath={loginPath} setLoginModalVisible={setLoginModalVisible} />
        </Modal>
    )
}